import { Link } from "react-router";

export const renderRouterLink = (domProps) =>
  "href" in domProps ? <Link to={domProps.href} {...domProps} /> : <div {...domProps} />;
